import React from 'react';
import Hdr from './shared/Hdr';
import { useState, useEffect } from 'react';
import swal from 'sweetalert';
import { apiPath } from "../src/services/apiConfig";

function HealthCard() {
  const user = localStorage.getItem('user-info');
  const token = localStorage.getItem('token');
  const usrRole = localStorage.getItem('user-role');
  const [displayOrganization, setDisplayOrganization] = useState('none');
  const [displayUpdOrganization, setDisplayUpdOrganization] = useState('none');
  const [data, setData] = useState([]);
  const [dataStat, setDataStat] = useState();
  const [OrganizationName, setOrganizationName] = useState('');
  const [OrganizationAddress1, setOrganizationAddress1] = useState('');
  const [OrganizationAddress2, setOrganizationAddress2] = useState('');
  const [OrganizationCity, setOrganizationCity] = useState('');
  const [OrganizationDistrict, setOrganizationDistrict] = useState('');
  const [OrganizationPin, setOrganizationPin] = useState('');
  //  const [uid, setUID] = useState('');
  //  const [specialityType, setSpecialityType] = useState('1');
  const [verfied, setVerfied] = useState(true);
  const [updOrganizationName, setOrganizationUpdName] = useState('');
  const [updOrganizationAddress1, setOrganizationUpdAddress1] = useState('');
  const [updOrganizationAddress2, setOrganizationUpdaddress2] = useState('');
  const [updOrganizationCity, setOrganizationUpdCity] = useState('');
  const [updOrganizationDistrict, setOrganizationUpdDistrict] = useState('');
  const [updOrganizationPin, setOrganizationUpdPin] = useState('');
  const [id, setID] = useState('');
  //  const [uidErr, setUIDErr] = useState('');
  //  const [Err, SetErr] = useState([]);

  let txt = "";


  useEffect(() => {
    getOrganization()
  }, [])

  function openOrganization() {
    setDisplayOrganization('block')
  }

  function closeOrganization() {
    setDisplayOrganization('none')
  }

  function openUpdOrganization() {
    setDisplayUpdOrganization('block')
  }

  function closeUpdUser() {
    setDisplayUpdOrganization('none')
  }

  async function updateOrganization(id) {

    let result = await fetch(apiPath + "updateOrg", {
      method: 'PUT',
      headers: {
        "Content-Type": "application/json",
        "Accept": "application/json",
        "Authorization": `Bearer ${token}`
      },
      body: JSON.stringify({
        "id": id,
        "name": updOrganizationName,
        "address_1": updOrganizationAddress1,
        "address_2": updOrganizationAddress2,
        "city": updOrganizationCity,
        "district": updOrganizationDistrict,
        "pin": updOrganizationPin
      })
    });
    result = await result.json();

    showSwal(result.success, result.message)

    getOrganization()
  }

  async function deleteOrganization(id) {

    let result = await fetch(apiPath + "Organizations/" + id, {
      method: 'DELETE',
      headers: {
        "Authorization": `Bearer ${token}`
      },
    });
    result = await result.json();

    showSwal(result.success, result.message)

    getOrganization()
  }


  async function updateOperation(id) {

    let result = await fetch(apiPath + "organisation/" + id,
      {
        method: 'GET',
        headers: {
          "Content-Type": "application/json",
          "Accept": "application/json",
          "Authorization": `Bearer ${token}`
        },
      });
    result = await result.json();

    console.warn(result.data)

    setOrganizationUpdName(result.data.name);
    setOrganizationUpdAddress1(result.data.address_1)
    setOrganizationUpdaddress2(result.data.address_2)
    setOrganizationUpdCity(result.data.city)
    setOrganizationUpdDistrict(result.data.district)
    setOrganizationUpdPin(result.data.pin)
    setID(result.data.id)

    openUpdOrganization();

  }

  function deleteOperation(id) {
    //alert(id)
    swal({
      title: "Are you sure?",
      text: "Deleting a Organization will DELETE all SPECIALITIES and DOCTORS linked to this departmnt. Once deleted, you will not be able to recover this data!",
      icon: "warning",
      buttons: true,
      dangerMode: true,
    })
      .then((willDelete) => {
        if (willDelete) {
          deleteOrganization(id);
        }
        else {
          swal("Your record is safe!");
        }
      });
  }


  //* LIST OF ALL Organization (for initial screen)*/ 

  async function getOrganization() {
    let result = await fetch(apiPath + "organisations",
      {
        method: 'GET',
        headers: {
          "Content-Type": "application/json",
          "Accept": "application/json",
          "Authorization": `Bearer ${token}`
        },
      })
    result = await result.json();

    setDataStat(result.success);
    setData(result.data);

    if (result.success === true) {
      setData(result.data);
    } else { setData([]) }
  }

  {/*
  function uidHandler(e) {
    setUIDErr('');
    e.preventDefault()
    let item = e.target.value
    if (!item) {
      setUIDErr("required")
    } else {
      setUID(item)
    }
  }
  */}

  function verifyOrganization() {
    setVerfied(true)
    addOrganization()
  }

  //*ADD A NEW Organization*/ 
  async function addOrganization() {
    //    alert('Add,'+OrganizationName)
    if (verfied) {

      let result = await fetch(apiPath + "storeOrg", {
        method: 'POST',
        headers: {
          "Content-Type": "application/json",
          "Accept": "application/json",
          "Authorization": `Bearer ${token}`
        },
        body: JSON.stringify({
          "name": OrganizationName,
          "address_1": OrganizationAddress1,
          "address_2": OrganizationAddress2,
          "city": OrganizationCity,
          "district": OrganizationDistrict,
          "pin": OrganizationPin
        })
      });
      result = await result.json();
      //  console.warn(result)

      //      if (result.success) { }
      //      else {
      //        SetErr(result.data);
      //      }

      showSwal(result.success, result.message)
      getOrganization()
    }
  }


  function showSwal(stat, txt) {
    if (stat === true) {
      swal({
        title: "Success!",
        text: txt,
        icon: "success",
        button: "OK!",
      });
    } else {
      swal({
        title: "Fail!",
        text: txt,
        icon: "error",
        button: "OK!",
      });
    }
  }


  return (

    <div style={{ 'height': '90vh' }}>
      <Hdr />
      <div className="row p16">
        <div className="c12-l-8">
          <h3 className="" >ADS Hospital - User : {user} </h3>
        </div>
        <div className="c12-l-4 pr32 ">
          <p className="medium right">User : ({usrRole})</p>
        </div>
      </div>

      <div className="row p16" style={{ 'height': '90%' }}>
        <div className=" c12-l-12 cont__content p4" style={{ 'height': '100%' }}>
          <div className="row p32">
            <div className="c12-l-3">
              <h4 className="wide">Health Card Organisation</h4>
            </div>
            <div className="c12-l-7"></div>
            <div className="c12-l-2">
              <button onClick={openOrganization} type="button" name="button"
                className="btn solid round">Create Organization</button>
            </div>
          </div>

          <div className="row mt16" >

            <table style={{ 'height': '100%', 'width': '100%', 'overflowY': 'scroll', 'overflowX': 'scroll', 'display': 'block' }}>
              <thead>
                <tr>
                  <th className="th-border center" width="5%">Id</th>
                  <th className="th-border left" width="20%">Name</th>
                  <th className="th-border left" width="20%">Address1</th>
                  <th className="th-border left" width="20%">Address2</th>
                  <th className="th-border left" width="20%">City</th>
                  <th className="th-border left" width="20%">District</th>
                  <th className="th-border left" width="15%">Pin</th>
                  <th className="th-border left" width="5%">Edit</th>
                  {/*      <th className="th-border left" width="5%">Delete</th>  */}
                </tr>
              </thead>
              <tbody >
                {
                  (dataStat === true ?
                    (
                      data.map((item, index) =>
                        <tr className="tr-border" key={index}>
                          <td className="center">{item.id}</td>
                          <td className="left">{item.name}</td>
                          <td className="left">{item.address_1}</td>
                          <td className="left">{item.address_2}</td>
                          <td className="left">{item.city}</td>
                          <td className="left">{item.district}</td>
                          <td className="left">{item.pin}</td>
                          <td onClick={() => { updateOperation(item.id) }} className="center"><img src={require('./asset/images/adm_edit.png')} alt="" /></td>
                          {/*                          <td onClick={() => { deleteOperation(item.id) }} className="center"><img src={require('./asset/images/adm_del.png')} alt="" /></td>  */}
                        </tr>
                      ))
                    : <tr><td>No data</td></tr>)
                }
              </tbody>
            </table>
          </div>

          {/* SCREEN FROM ADDING NEW USER */}

          <div id="newdept" style={{ 'display': displayOrganization }} className="cont__new-dept">
            <form className="" action="" method="">
              <div className="row">
                <div className="c12-l-11"></div>
                <div className="c12-l-1 center">
                  <p onClick={closeOrganization}><img src={require('./asset/images/adm_close.png')} alt="" width="24px" height="24px" /></p>
                </div>
              </div>

              <div className="row mt32">
                <div className="c12-l-12">
                  <h2>Add Organization</h2>
                  <br />
                  <div className="row">
                    <div className="c12-l-12">

                      <p style={{ 'fontSize': '0.65rem' }}>Organization Name</p>
                      <input style={{ 'fontSize': '1.0rem' }} type="text" className="box small" autoComplete="off"
                        placeholder="Organization Name" onChange={(e) => setOrganizationName(e.target.value)} />

                      <p style={{ 'fontSize': '0.65rem' }}>Address1</p>
                      <input style={{ 'fontSize': '1.0rem' }} type="text" className="box small" autoComplete="off"
                        placeholder="Address Line 1" onChange={(e) => setOrganizationAddress1(e.target.value)} />

                      <p style={{ 'fontSize': '0.65rem' }}>Address2</p>
                      <input style={{ 'fontSize': '1.0rem' }} type="text" className="box small" autoComplete="off"
                        placeholder="Address Line 2" onChange={(e) => setOrganizationAddress2(e.target.value)} />

                      <p style={{ 'fontSize': '0.65rem' }}>City/Town</p>
                      <input style={{ 'fontSize': '1.0rem' }} type="text" className="box small" autoComplete="off"
                        placeholder="City/Town" onChange={(e) => setOrganizationCity(e.target.value)} />

                      <p style={{ 'fontSize': '0.65rem' }}>District</p>
                      <input style={{ 'fontSize': '1.0rem' }} type="text" className="box small" autoComplete="off"
                        placeholder="District" onChange={(e) => setOrganizationDistrict(e.target.value)} />

                      <p style={{ 'fontSize': '0.65rem' }}>Pin</p>
                      <input style={{ 'fontSize': '1.0rem' }} type="text" className="box small" autoComplete="off"
                        placeholder="Pin" onChange={(e) => setOrganizationPin(e.target.value)} />

                    </div>
                  </div>

                  <button onClick={verifyOrganization} type="button"
                    className="btn solid round">Add Organization</button>
                </div>
              </div>
            </form>
          </div>

          {/* SCREEN FROM UPDTAE EXISTING USER */}

          <div id="newdept" style={{ 'display': displayUpdOrganization }} className="cont__new-dept">
            <form className="" action="" method="">
              <div className="row">
                <div className="c12-l-11"></div>
                <div className="c12-l-1 center">
                  <p onClick={closeUpdUser}><img src={require('./asset/images/adm_close.png')} alt="" width="24px" height="24px" /></p>
                </div>
              </div>

              <div className="row mt32">
                <div className="c12-l-12">
                  <h2>Edit Organization</h2><br />

                  <div className="c12-l-12">

                    <input type="hidden" value={id} />

                    <p style={{ 'fontSize': '0.65rem' }}>Organization Name</p>
                    <input type="text" className="box small" autoComplete="off"
                      placeholder="Name of the Organization" onChange={(e) => setOrganizationUpdName(e.target.value)}
                      value={updOrganizationName} />

                    <p style={{ 'fontSize': '0.65rem' }}>Address1</p>
                    <input type="text" className="box small" autoComplete="off"
                      placeholder="Address Line 1" onChange={(e) => setOrganizationUpdAddress1(e.target.value)}
                      value={updOrganizationAddress1} />

                    <p style={{ 'fontSize': '0.65rem' }}>Address2</p>
                    <input style={{ 'resize': 'none' }} type="text" className="box small" autoComplete="off"
                      placeholder="Address Line 2" onChange={(e) => setOrganizationUpdaddress2(e.target.value)}
                      value={updOrganizationAddress2} />

                    <p style={{ 'fontSize': '0.65rem' }}>City/Town</p>
                    <input style={{ 'resize': 'none' }} type="text" className="box small" autoComplete="off"
                      placeholder="City/Town" onChange={(e) => setOrganizationUpdCity(e.target.value)}
                      value={updOrganizationCity} />

                    <p style={{ 'fontSize': '0.65rem' }}>District</p>
                    <input style={{ 'resize': 'none' }} type="text" className="box small" autoComplete="off"
                      placeholder="District" onChange={(e) => setOrganizationUpdDistrict(e.target.value)}
                      value={updOrganizationDistrict} />

                    <p style={{ 'fontSize': '0.65rem' }}>Pin</p>
                    <input style={{ 'fontSize': '1.0rem' }} type="text" className="box small" autoComplete="off"
                      placeholder="Pin" onChange={(e) => setOrganizationUpdPin(e.target.value)}
                      value={updOrganizationPin} />
                  </div>

                  <button onClick={() => { updateOrganization(id) }} type="button"
                    className="btn solid round">Update</button>
                </div>
              </div>
            </form>
          </div>
        </div>
      </div>
    </div>
  );
}

export default HealthCard;
